import { persistOptionSelections as persistConfiguratorOptionSelections } from "../apps/configurator/persistence";
import { persistOptionSelections as persistGridOptionSelections } from "../apps/product-grid2/persistence";

export const middleware = [
    persistConfiguratorOptionSelections,
    persistGridOptionSelections,
] as const;
